<template>
  <div class="pointsDetails">
    <div>
      <module-title title="积分明细">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('close')">
            返回
          </el-button>
        </div>
      </module-title>
      <div>
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="变动依据：" prop="srcId">
            <el-input
              v-model="searchForm.srcId"
              name="srcId"
              maxlength="200"
              placeholder="输入变动依据"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="变动来源：" prop="productCode">
            <el-select
              v-model="searchForm.productCode"
              name="productCode"
              size="medium"
              class="edit-form-input"
            >
              <el-option key="" label="全部" value="" />
              <el-option
                v-for="item in appCodeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="变动类型：" prop="changeType">
            <el-select
              v-model="searchForm.changeType"
              name="changeType"
              size="medium"
              class="edit-form-input"
            >
              <el-option key="" label="全部" value="" />
              <el-option
                v-for="item in changeTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="变动时间：" prop="advertisementType">
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="起始时间"
              end-placeholder="截至时间"
              :picker-options="datePickerOptions"
              @change="handleChangeDate"
              @blur="dateBlur"
            />
          </el-form-item>
          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="pointsList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="变动时间" align="center" prop="createDate" />
          <el-table-column label="变动来源" prop="appName" align="center" />
          <el-table-column label="变动依据" prop="srcId" align="center" />
          <el-table-column label="变动类型" prop="changeType" align="center">
            <template slot-scope="scope">
              <p v-for="item in changeTypeList" v-show="scope.row.changeType===item.id" :key="item.id">
                {{ item.name }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="初始值" prop="preAvailable" align="center" />
          <el-table-column label="变动值" prop="value" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.value>0">
                <span v-show="scope.row.changeType===1">+{{ scope.row.value }}</span>
                <span v-show="scope.row.changeType===2">-{{ scope.row.value }}</span>
              </span>
              <span v-else>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="可用积分小计" prop="available" align="center" width="128" />
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { getIntegralList } from '@/api/userManagement/index/';
import {
  getDictsType
} from '@/api/productOperation/public/advertisementManage';
import { getNowFormatDate, getupFormatDate } from '@/utils/index';
export default {
  name: 'PortraitManage',
  props: {
    userProps: {
      default: Object,
      type: Object
    }
  },
  data() {
    return {
      // 搜索表单
      dictsType: 'user_source',
      searchForm: {
        accountId: '',
        changeType: '',
        productCode: '',
        srcId: '',
        beginTime: getupFormatDate(null, null, 3),
        endTime: getNowFormatDate(),
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      pointsList: [],
      appCodeList: [],
      listLoading: false, // 表格刷新loading
      dateTime: [getupFormatDate(null, null, 3), getNowFormatDate()],
      pickerMinDate: '',
      datePickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 3 * 30 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      }
    };
  },
  computed: {
    changeTypeList() {
      return [
        {
          id: 1,
          name: '增加'
        },
        {
          id: 2,
          name: '减少'
        }
      ];
    }
  },
  watch: {
    // 路由监听赋值三级菜单
    userProps: {
      handler: function(val, oldVal) {
        this.fetchPointsList();
      },
      // $route这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  mounted() {
    this.getType();
    this.fetchPointsList();
  },
  methods: {
    dateBlur() {
      this.pickerMinDate = '';
    },
    getType() {
      getDictsType(this.dictsType).then(res => {
        this.appCodeList = res.data;
      });
    },
    // 获取积分明细数据
    fetchPointsList() {
      this.listLoading = true;
      var options = {
        accountId: this.userProps.accountId,
        productCode: this.searchForm.productCode,
        changeType: this.searchForm.changeType,
        srcId: this.searchForm.srcId,
        beginTime: this.searchForm.beginTime,
        endTime: this.searchForm.endTime,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getIntegralList(options).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.pointsList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.pointsList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.pointsList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.beginTime = val[0];
        this.searchForm.endTime = val[1];
        this.fetchPointsList();
      } else {
        this.searchForm.beginTime = '';
        this.searchForm.endTime = '';
      }
      this.dateBlur();
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchPointsList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchPointsList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchPointsList();
    }
  }
};
</script>
<style lang="scss" scoped>
.pointsDetails {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
</style>
